module.exports = __webpack_public_path__ + "img/2.6681bfd3.jpg";